export const normalize = (str = '') => {
  const FROM = 'ÃÀÁÄÂÇÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛÑãàáäâèéëêìíïîòóöôùúüûñç'
  const TO = 'AAAAACEEEEIIIIOOOOUUUUNaaaaaeeeeiiiioooouuuunc'
  const mapping = {}

  for (let i = 0, j = FROM.length; i < j; i++) {
    mapping[FROM.charAt(i)] = TO.charAt(i)
  }

  const ret = []
  for (let i = 0, j = str.length; i < j; i++) {
    const c = str.charAt(i)

    if (Object.prototype.hasOwnProperty.call(mapping, str.charAt(i))) {
      ret.push(mapping[c])
    } else {
      ret.push(c)
    }
  }
  return ret.join('').toLowerCase()
}

export const KEY_CODES = {
  ENTER: 13,
  BACKSPACE: 8,
  ARROW_UP: 38,
  ARROW_DOWN: 40
}

export const pad2 = (number) => {
  return (number < 10 ? '0' : '') + number
}
